"use client";
import Link from "next/link";
import React from "react";
import Image from "next/image";
import { useState, useEffect } from "react";

// const egames = [
//   {
//     title: "Gaming Focus Mode",
//     description:
//       "This image captures a modern gamer fully immersed in a digital world. Sitting comfortably in a stylish gaming chair, the player is deeply focused on the screen, showcasing the intensity and concentration that gaming demands. The setup reflects a professional or serious gaming environment, possibly indicating streaming, competitive play, or long gaming sessions. The lighting and posture suggest dedication, while the minimal distractions highlight how gaming has evolved into a structured and engaging activity. Today, gaming is not just entertainment but also a career path for many, including esports players and content creators. This scene perfectly represents the growing culture of gaming, where skill, strategy, and quick reflexes matter. The individual appears calm yet alert, balancing enjoyment with performance. It also symbolizes how technology has become an integral part of daily life, offering immersive experiences that connect players globally. Overall, this image portrays passion, focus, and the evolving digital lifestyle of modern gamers.",
//     image: "/assets/img/egame-1.jpg",
//   },
//   {
//     title: "Arcade Chill Vibes",
//     description:
//       "This image showcases a relaxed and fun gaming atmosphere, likely set in an arcade environment. The subject appears to be enjoying a casual gaming moment, surrounded by vibrant lights and colorful machines that create an energetic yet laid-back vibe. Unlike intense competitive setups, this scene highlights gaming as a social and recreational activity. Arcades have always been places where people gather to unwind, compete lightly, and enjoy classic games. The person’s relaxed posture and expression suggest enjoyment without pressure, making it relatable for everyday players. The lighting enhances the mood, giving a nostalgic yet modern feel, blending traditional arcade culture with contemporary aesthetics. This image represents how gaming can be both entertaining and stress-relieving, offering a break from routine life. It also reflects the importance of shared experiences, as arcade spaces often bring friends together. Overall, this scene captures the joy, color, and casual fun that gaming environments provide.",
//     image: "/assets/img/egame-2.jpg",
//   },
//   {
//     title: "Water Adventure Rush",
//     description:
//       "This image captures an exciting moment of outdoor fun and adventure in a water park setting. The person is mid-action, jumping or splashing into the water with visible energy and enthusiasm. The bright surroundings, water slides, and summer vibe create a refreshing and lively atmosphere. This scene represents the thrill of outdoor activities, where people can break free from routine and enjoy moments of pure joy. The subject’s movement and expression highlight excitement, spontaneity, and freedom. Water parks are often associated with fun, laughter, and unforgettable memories, especially during hot weather. This image also symbolizes the importance of leisure and recreation in maintaining a balanced lifestyle. The vibrant colors and dynamic motion make the moment feel alive and engaging. It’s not just about the activity but the experience of living in the moment. Overall, this image reflects happiness, adventure, and the refreshing escape that outdoor water experiences provide.",
//     image: "/assets/img/egame-3.jpg",
//   },
//   {
//     title: "Arcade Chill Vibes",
//     description:
//       "This image shows a playful and energetic water fight scene, where the person is actively engaging in a splash battle using a water gun. The bright sunlight and outdoor setting add to the cheerful and lively mood. The subject’s expression and body language reflect excitement, fun, and a carefree spirit. This kind of activity is often associated with summer, friends, and outdoor gatherings, making it highly relatable and joyful. Water fights are simple yet highly enjoyable, bringing out the inner child in everyone. The image captures movement and action, making it dynamic and engaging. It also symbolizes bonding and shared happiness, as such activities are usually enjoyed with others. The vibrant colors and splashing water enhance the visual appeal, creating a sense of freshness and energy. Overall, this image represents fun, playfulness, and the joy of simple outdoor moments that create lasting memories.",
//     image: "/assets/img/egame-4.jpg",
//   },
// ];

export default function EGames() {
  const [egames, setEgames] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchEgames = async () => {
      try {
        const response = await fetch("/api/egames");
        if (response.ok) {
          const data = await response.json();
          setEgames(data.egames || []);
        }
      } catch (error) {
        console.error("Failed to fetch E-Games:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEgames();
  }, []);
  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: 'url("/assets/img/banners/egames_bg_new.webp")',
        }}
      >
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  E-Games
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>E-Games</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="about-section fix section-padding">
        <div className="container packagefulldetails">
          {loading ? (
            <div className="text-center">
              <h3>Loading E-Games...</h3>
            </div>
          ) : (
            egames.map((item, index) => (
              <div className="row mb-lg-5 mb-md-3" key={index}>
                {index % 2 === 0 ? (
                  <>
                    <div className="col-lg-5">
                      <img
                        src={item.image}
                        alt={item.title}
                        style={{
                          height: "400px",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        className="faqbg"
                      />
                    </div>
                    <div className="col-lg-7">
                      <h2 className="pb-4">{item.title}</h2>
                      <p>{item.description}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-lg-7 order-lg-0 order-1">
                      <h2 className="pb-4">{item.title}</h2>
                      <p>{item.description}</p>
                    </div>
                    <div className="col-lg-5 order-lg-1 order-0">
                      <img
                        src={item.image}
                        alt={item.title}
                        style={{
                          height: "400px",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        className="faqbg"
                      />
                    </div>
                  </>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
